import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import {
  Table,
  IconButton,
  Icon,
  Panel,
  ButtonGroup,
  Button,
  Row,
  Col,
  Uploader,
  Dropdown,
  Checkbox,
  Modal,
  Input,
  SelectPicker,
} from 'rsuite'
// รอแก้
// import { initialNewData, getExpandedId, getNewDataEdit } from './ExpenseRecordUtils'
import EditSelectCell from '../../../components/cell/EditSelectCell'
import EditTextCell from '../../../components/cell/EditTextCell'
import EditNumberCell from '../../../components/cell/EditNumberCell'
import Notebook from '../../../resources/images/notebook.jpg'
import Bill from '../../../resources/images/bill.png'
import QrMock from '../../../resources/images/qrMock.png'
import { budgetFormat } from '../../../utils/formatterUtil'

export default function BookingManagementScholarsTable({ schema, loading, ...props }) {
  const { register, handleSubmit, errors, control, setError, clearErrors } = useForm()
  const { Column, HeaderCell, Cell } = Table
  const [tableData, setTableData] = useState([])
  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false)
  const [showControlEdit, setShowControlEdit] = useState(true)
  const [isShowDetailList, setIsShowDetailList] = useState(false)
  const [isShowDocument, setShowDocument] = useState(false)
  const [isShowPic, setShowPic] = useState(false)

  const [checkedKeys, setCheckedKeys] = useState([])
  let checked = false
  let indeterminate = false

  useEffect(() => {
    setTableData(schema.values)
  }, [schema.values])

  const handleOpenEditRow = (rowData) => {
    // console.log('handleOpenEditRow ', rowData)
    console.log('row ', tableData)
    tableData.map((item) => {
      if (item.id) {
        const nextData = getNewDataEdit(tableData, item)
        setTableData(nextData)
      }
    })

    // setShowControlEdit(!showControlEdit)
  }

  const handleCheckAll = (value, checked) => {
    const keys = checked ? tableData.map((item) => item.id) : []
    setCheckedKeys(keys)
  }

  const handleCheck = (value, checked) => {
    const keys = checked ? [...checkedKeys, value] : checkedKeys.filter((item) => item !== value)
    setCheckedKeys(keys)
  }

  const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, ...props }) => (
    <Cell {...props} style={{ padding: 0 }}>
      <div style={{ lineHeight: '46px' }}>
        <Checkbox
          value={rowData[dataKey]}
          inline
          onChange={onChange}
          checked={checkedKeys.some((item) => item === rowData[dataKey])}
        />
      </div>
    </Cell>
  )

  const handleTest = () => {
    console.log('handleTest ')
  }

  return (
    <>
      <Table wordWrap autoHeight loading={loading} data={tableData} style={{ marginTop: '20px' }}>
        <Column width={100} align="center">
          <HeaderCell>
            <Checkbox style={{ marginTop: '-7px' }}>
              {' '}
              <b>ลำดับ</b>
            </Checkbox>
          </HeaderCell>
          <Cell>
            {(rowData, index) => {
              if (rowData.bookingStatus == 'is_expire') {
                return ''
              }

              return <Checkbox style={{ marginTop: '-7px' }}> {index + 1}</Checkbox>
            }}
          </Cell>
        </Column>

        <Column width={180}>
          <HeaderCell>รหัสครุภัณฑ์</HeaderCell>
          <Cell dataKey="assetCode" />
        </Column>

        <Column width={150}>
          <HeaderCell>ชื่อครุภัณฑ์</HeaderCell>
          <Cell dataKey="assetName" />
        </Column>

        <Column width={150}>
          <HeaderCell>ราคา/หน่วย</HeaderCell>
          <Cell>
            {(rowData) => {
              return budgetFormat(rowData.pricePerUnit)
            }}
          </Cell>
        </Column>

        <Column width={150}>
          <HeaderCell>รุ่น</HeaderCell>
          <Cell dataKey="brand" />
        </Column>

        <Column width={150}>
          <HeaderCell>ยี่ห้อ</HeaderCell>
          <Cell dataKey="model" />
        </Column>

        <Column width={150} align="center">
          <HeaderCell>ประเภทครุภัณฑ์ </HeaderCell>
          <Cell dataKey="assetType" />
        </Column>

        <Column width={150}>
          <HeaderCell>สำนักที่จอง</HeaderCell>
          <Cell dataKey="bookingOfDepartment" />
        </Column>

        <Column width={200}>
          <HeaderCell>ผู้ขอจอง </HeaderCell>
          <Cell dataKey="coodinator" />
        </Column>

        <Column width={100}>
          <HeaderCell>สถานะการจอง </HeaderCell>
          <Cell dataKey="bookingStatusName" />
        </Column>

        <Column width={200}>
          <HeaderCell>วันที่หมดอายุการจอง</HeaderCell>
          <Cell dataKey="expirationDate" />
        </Column>
        <Column width={150}>
          <HeaderCell>แนบรูปภาพครุภัณฑ์</HeaderCell>
          {/* <Cell dataKey="list" /> */}
          <Cell>
            {(rowData) => {
              return (
                <>
                  <a
                    style={{ cursor: 'pointer', textDecorationLine: 'underline' }}
                    onClick={(e) => {
                      setShowPic(true)
                    }}
                  >
                    <Icon icon="file-image-o" style={{ marginRight: '5px' }} />
                    คลิกดูรูปภาพ
                  </a>
                </>
              )
            }}
          </Cell>
        </Column>

        <Column width={200}>
          <HeaderCell>หมายเหตุ</HeaderCell>
          <Cell dataKey="note" />
        </Column>

        <Column width={150}>
          <HeaderCell>เอกสารประกอบ</HeaderCell>
          <Cell>
            {(rowData) => {
              return (
                <>
                  <a
                    style={{ cursor: 'pointer', textDecorationLine: 'underline' }}
                    onClick={(e) => {
                      setShowDocument(true)
                    }}
                  >
                    <Icon icon="file" style={{ marginRight: '5px' }} />
                    คลิกดูรูปภาพ
                  </a>
                </>
              )
            }}
          </Cell>
        </Column>
      </Table>

      {/* Modal เอกสารประกอบ */}
      <Modal
        show={isShowDocument}
        width="300"
        onHide={(e) => {
          setShowDocument(false)
        }}
      >
        <Modal.Header>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table wordWrap autoHeight loading={loading} data={tableData}>
            <Column width={100} align="center">
              <HeaderCell>ลำดับ</HeaderCell>
              <Cell>
                {(_, index) => {
                  return index + 1
                }}
              </Cell>
            </Column>
            <Column width={250} align="center">
              <HeaderCell>ชื่อเอกสาร </HeaderCell>
              <Cell dataKey="documentName" />
            </Column>
            <Column width={200} align="center">
              <HeaderCell>ไฟล์ </HeaderCell>
              <Cell>
                {(rowData) => {
                  if (!rowData.isDeletable) {
                    return rowData.test2
                  }
                  return <Icon icon="file" />
                }}
              </Cell>
            </Column>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          {/* <Button
            onClick={(e) => {
              setIsTest4(false)
            }}
            appearance="primary"
          >
            ส่งขอขึ้นทะเบียน
          </Button>
          <Button
            onClick={(e) => {
              setIsTest4(false)
            }}
            color="blue"
            appearance="primary"
          >
            ยกเลิก
          </Button> */}
        </Modal.Footer>
      </Modal>

      {/* Modal Show Pic */}
      <Modal
        show={isShowPic}
        size="md"
        onHide={(e) => {
          setShowPic(false)
        }}
      >
        <Modal.Header>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Panel>
            <div>
              <img src={Notebook} alt="Notebook" style={{ width: 300, marginLeft: 150 }} />
            </div>
          </Panel>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>

      {/* )} */}
    </>
  )
}
